import type { LeafAnimation } from '@/types';
import useInterval from '@/utils/useInterval';
import { type CSSProperties, useState } from 'react';
import { AnimatedTextScroll } from './AnimatedTextScroll';

export function AnimatedText({
  animation,
  style,
}: {
  animation: LeafAnimation | undefined;
  style: CSSProperties | undefined;
}) {
  if (!animation) return null;
  const { type, words } = animation;

  const [currIdx, setcurrIdx] = useState(0);
  useInterval(() => {
    setcurrIdx((currIdx + 1) % (words?.length || 0));
  }, 2500);

  if (words?.length === 0) return null;

  if (type === 'scroll_words' && words.length > 1) {
    return <AnimatedTextScroll words={words} currIdx={currIdx} style={style} />;
  }

  return <>{words?.[0]}</>;
}
